var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.027 6.96L11.3514 11.2L7 8.16L2.64865 11.2L3.97297 7.04L0 4.24L5.10811 4L7 0L8.89189 4L14 4.24L10.027 6.96ZM8.89189 13.6H7.94595V11.2L7 10.4L6.05405 11.2V13.6H5.10811C4.06757 13.6 3.21622 14.32 3.21622 15.2V16H10.7838V15.2C10.7838 14.7757 10.5845 14.3687 10.2297 14.0686C9.87486 13.7686 9.39365 13.6 8.89189 13.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e24d962c1a26926b230919025d231fe5.svg";
export { ForwardRef as ReactComponent };